import axiosIns from '@/plugins/axios'

export default {
  // current_clubに解決済み(グループ設定+club上書き適用後)の取引先一覧
  getSuppliers() {
    return axiosIns.get(
      '/v2/eod_closing/expense_suppliers',
    )
  },
}
